import { render, staticRenderFns } from "./LogoutSection.vue?vue&type=template&id=4cca5d57&"
import script from "./LogoutSection.vue?vue&type=script&lang=js&"
export * from "./LogoutSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports